import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import { useScreenSize } from '../../context/ScreenSizeContext';
import CheckoutSideBar from './checkout-sidebar/CheckoutSidebar';
import Menu from './Menu';

const MenuSwitch: FC = () => {
  const { isPhone } = useScreenSize();

  return (
    <Routes>
      <Route path="cart" element={isPhone ? <CheckoutSideBar /> : null} />
      <Route path="*" element={<Menu />} />
    </Routes>
  );
};

export default MenuSwitch;
